export default __webpack_public_path__ + "static/media/07.cf21c96f.jpg";